"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainPage = void 0;
const React = __importStar(require("react"));
const top_section_1 = __importDefault(require("./components/top-section"));
const auction_tape_1 = __importDefault(require("./components/auction-tape"));
const collection_tape_1 = __importDefault(require("./components/collection-tape"));
require("./styles.scss");
const recent_list_1 = __importDefault(require("./components/recent-list"));
const MainPage = (props) => {
    return (React.createElement("div", { className: "p-main-page" },
        React.createElement("div", { className: "p-main-page__top-section" },
            React.createElement(top_section_1.default, null)),
        React.createElement("div", { className: "p-main-page__content" },
            React.createElement(auction_tape_1.default, null)),
        React.createElement("div", { className: "p-main-page__content" },
            React.createElement(collection_tape_1.default, null)),
        React.createElement("div", { className: "p-main-page__recent" },
            React.createElement(recent_list_1.default, null))));
};
exports.MainPage = MainPage;
exports.default = exports.MainPage;
